import React from 'react';
import { Box, ResponsiveContext } from 'grommet';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import GatsbyAnchor from '../../components/GatsbyAnchor';
import BodyText from '../../typography/BodyText';

const StyledBox = styled(Box)`
  display: inline-flex;
  width: 100vw;

  a {
    letter-spacing: 0.08px;
    line-height: 30px;
  }
`;

const StyledRichText = styled(BodyText)`
  display: flex;
  p {
    margin: 0;
  }
`;

export default function Banner({ Link, content, htmlSerializer }) {
  return (
    <ResponsiveContext.Consumer>
      {(size) => {
        const isSmall = size === 'small';
        const align = 'center';
        return (
          <StyledBox as="banner">
            <Box
              width={isSmall ? 'full' : 'medium'}
              height={isSmall ? 'auto' : '50px'}
              align={align}
              flex="shrink"
              style={{
                display: 'inline-flex',
                flexDirection: isSmall ? 'column' : 'row',
                justifyContent: 'center',
                width: '100%',
                background: '#cb361d',
                color: '#ffffff',
                fontFamily: 'Roboto Slab,serif',
              }}
            >
              <StyledRichText textAlign={align} color="white" margin={{ right: '8px' }}>
                <RichText
                  render={content.title}
                  htmlSerializer={htmlSerializer}
                  size={isSmall ? '12px' : '18px'}
                />
              </StyledRichText>
              <GatsbyAnchor Link={Link} href={content.hyperlink.url} style={{ color: 'inherit' }}>
                <StyledRichText textAlign={align} color="white">
                  <RichText
                    render={content.hyper_link_text}
                    htmlSerializer={htmlSerializer}
                    size={isSmall ? '12px' : '18px'}
                  />
                </StyledRichText>
              </GatsbyAnchor>
            </Box>
          </StyledBox>
        );
      }}
    </ResponsiveContext.Consumer>
  );
}
